import { ITopicTarget } from './types';

const MAX_RETRY_DELAY_MS = 30_000;
const SUPPORTED_SCHEMA_VERSION = 1;

/** Exponential backoff capped at 30 s, with jitter so that tabs do not reconnect all at once. */
export const getRetryDelay = (previousRetryCount: number): number =>
  Math.min(MAX_RETRY_DELAY_MS, 1_000 * 2 ** previousRetryCount) * (0.5 + Math.random() / 2);

export const getTopicKey = ({ topic, serviceCenterId }: ITopicTarget): string =>
  `${topic}:${serviceCenterId}`;

/** Within a schema version fields are only ever added, so another version can't be read safely. */
export const isSupportedSchema = (payload?: { schemaVersion?: number } | null): boolean =>
  payload?.schemaVersion === SUPPORTED_SCHEMA_VERSION;
